import { makeStyles } from "@material-ui/core";
const useStyles = makeStyles((theme) => ({
  pointer: {
    cursor: "pointer",
  },
}));
export { useStyles };
